export const EXPERIENCES_HEADER = "Activities";

export const UPDATE_CALENDAR_TEXT = "Choose dates";

export const WHERE_TO = "Where to?";

export const CHANGE_CTA_TEXT = "Change";
export const CONTACT_INFORMATION = "Contact information";
export const DATE = "Date";
export const START_TIME = "Start time";
export const TRAVELERS = "Travelers";
export const OPERATOR = "Operator";
export const TOTAL_NUM_TRAVELERS = (totalTravelers: number) =>
  `${totalTravelers} ${totalTravelers === 1 ? "Traveler" : "Travelers"}`;

export const TAXES_AND_FEES_INCLUDED = "Price is inclusive of taxes.";
export const MANDATORY_FEES_BELOW =
  "Any fees due at the time of the activity are shown below.";
export const MANDATORY_FEES_TOOLTIP_TEXT =
  "All additional fees are calculated based on the total number of travelers. Fees may vary upon arrival to your activity.";
export const FREE_CANCELLATION = "Free cancellation";
export const VIEW_POLICY_DETAILS = "View policy details";
export const CANCELLATION_POLICY = "Cancellation policy";
export const ADDITIONAL_DETAILS = "Additional details";

export const CONTINUE_TEXT = "Continue";
export const SEARCH_AGAIN = "Search again";
export const GO_BACK = "Go back";
